import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'
// import createLogger from 'vuex/dist/logger'
import createPersistedState from 'vuex-persistedstate'

// Modules
import userModule from './user'
import drawerModule from './../store'
Vue.use(Vuex)
Vue.use(VueResource)

Vue.config.debug = true

// const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
  modules: {
    user: userModule,
    drawer: drawerModule,
  },
  strict: false,
  // middlewares: debug ? [createLogger()] : [],
  plugins: [
    createPersistedState(),
  ],
})

export default store
